import AttachmentOutlined from "@mui/icons-material/AttachmentOutlined";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIcon } from "../ListStateIcon";

interface IListStateIconAttachmentProps {
    hasAttachments: boolean
}

export const ListStateIconAttachment = (props: IListStateIconAttachmentProps) => {
    if (!props.hasAttachments) return null;
    return (
        <ListStateIcon
            tooltip={Translations.HasAttachments}
            icon={AttachmentOutlined}
        />
    );
};
